export const environment = {
  production: `false`,
  launchcontrolAdminDomain: `test1-admin.dealerteamwork.com`,
  launchcontrolApiDomain: `test1-api.dealerteamwork.com`,
  autoDomain: `auto-api.test1-admin.dealerteamwork.com`,
  autoPort: `443`,
  mpopDomain: `adflex-api.test1-admin.dealerteamwork.com`,
  envName: `undefined`
};
